// The video editor's text strings (components/Editor), under t('editor.rve.text.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  transcript: {
    heading: 'الكلام المكتوب',
    wordsOne: '{n} كلمة',
    wordsMany: '{n} كلمة',
    seconds: '{n} ث',
    minutes: '{m} د {s} ث',
    editWord: 'عدّل الكلمة',
    noPauses: 'المقطع ده مافيهوش سكتات طويلة.',
    cutSpeaker: 'اقطع كل كلام {name} ({n} كلمة)',
    speakerMenu: '{name}: كلامه',
    cantListen: 'ماقدرناش نسمع صوت المقطع ده. جرّب تاني كمان شوية.',
    emptyTitle: 'مفيش كلام مكتوب تعدّل فيه',
    emptyBody: 'الكلام المكتوب بييجي من كابشن الفيديو ده. ضيف كابشن وكلامه هيظهر هنا: اقطع كلمة وهتتقص من الفيديو.',
    removeFillersTitle: 'بيقص كل "اممم" و"إيه" و"آآ"',
    removeFillers: 'شيل الأصوات الزيادة ({n})',
    removePausesTitleClip: 'بيسمع المقطع ويقصّر كل سكتة أطول من 0.6 ثانية',
    removePausesTitle: 'بيقصّر كل سكتة أطول من 0.7 ثانية',
    listening: 'بندوّر على السكتات…',
    removePauses: 'شيل السكتات',
    removePausesCount: 'شيل السكتات ({n} · {duration})',
    emphasizeTitle: 'الكلمات المهمة بتفضل بلون التمييز بتاع الكابشن',
    unmark: 'شيل التمييز',
    emphasize: 'ميّزها',
    cut: 'اقطع',
    clearSelection: 'الغي التحديد',
    hintTitle: 'دوس على كلمة تروح لها · Shift مع الدوسة أو اسحب عشان تحدد · Delete بيقطع اللي محدد · دوس مرتين على كلمة عشان تصلّحها',
    hint: "دوس تروح لها · {key} يقطع · دوستين تصلّح",
    deleteKey: "Delete",
    nothingToRemove: "مفيش كلمات حشو ولا سكتات طويلة تتشال.",
    hintTouch: "دوس على كلمة تتحدد · اقطعها أو صلّحها من الشريط",
    fixWord: "صلّح",
  },

  transcribe: {
    uploadedVideo: 'فيديو مرفوع',
    jobTitle: 'كابشن · {name}',
    video: 'فيديو',
    transcribe: 'فرّغ الكلام',
    carriesOn: '{step}… هيكمّل حتى لو غيّرت اللوحة.',
    dismiss: 'اقفل',
    usesMinutes: 'بيحسب من دقايق باقتك، زي الكابشن التلقائي. الكابشن بينزل على التايم لاين تحت الفيديو.',
  },

  captions: {
    srtFailed: 'ماقدرناش نقرا ملف SRT: عدد الأخطاء {n}',
    noCaptionsInSrt: 'مالقيناش كابشن في ملف SRT.',
    invalidJson: 'شكل ملف JSON غلط. المفروض يكون { words: [...] }',
    jsonFailed: 'ماقدرناش نقرا ملف JSON. راجع شكله.',
    textFailed: 'ماقدرناش نقرا ملف النص.',
    unsupported: 'نوع الملف ده مش مدعوم. استخدم .srt أو .json أو .txt',
    line: 'سطر {n}',
    moreErrors: '...و{n} أخطاء كمان',
    dismiss: 'اقفل',
    processing: 'بنجهّزه...',
    upload: 'ارفع ملف ترجمة',
    supported: 'المدعوم: .srt و.json و.txt',
    srtHelp: 'ملفات SRT فيها توقيت كل سطر بالظبط. تقدر تصدّر SRT من أغلب برامج تفريغ الكلام.',
    or: 'أو',
    scriptPlaceholder: 'اكتب أو الزق السكريبت بتاعك هنا...',
    generate: 'اعمل الكابشن',
    clear: 'امسح',
    label: 'الكابشن',
    seekTo: 'روح لـ {time}',
    start: 'البداية',
    end: 'النهاية',
    textPlaceholder: 'اكتب كلام الكابشن...',
  },

  srt: {
    empty: 'الملف فاضي',
    tooShort: 'الملف قصير أوي: لازم يكون فيه سطر ترجمة واحد على الأقل',
    noTimestamps: 'مالقيناش توقيتات SRT صح. الشكل المطلوب: HH:MM:SS,mmm --> HH:MM:SS,mmm',
    badNumber: 'رقم السطر غلط: "{value}"',
    noTiming: 'سطر التوقيت ناقص',
    badTiming: 'شكل التوقيت غلط: "{value}"',
    badTime: 'التوقيت غلط في السطر {n}',
    startAfterEnd: 'البداية لازم تكون قبل النهاية في السطر {n}',
    noText: 'مفيش كلام في السطر {n}',
    emptyText: 'كلام السطر {n} فاضي',
    blockFailed: 'ماقدرناش نقرا السطر {n}',
    overlap: 'توقيت السطر {a} داخل في السطر {b}',
  },

  srtErrors: {
    title: 'ماقدرناش نقرا ملف SRT',
    file: 'الملف:',
    foundOne: 'لقينا {n} غلطة في ملف SRT.',
    foundMany: 'عدد الأخطاء في ملف SRT: {n}.',
    fixAndRetry: 'صلّحها وجرّب تاني.',
    someSkipped: 'ممكن شوية سطور تكون اتشالت.',
    validation: 'غلط في الملف',
    format: 'غلط في الشكل',
    timing: 'غلط في التوقيت',
    encoding: 'غلط في الترميز',
    error: 'غلط',
    solutionsTitle: 'حلول بتنفع غالبًا:',
    solutions: [
      'اتأكد إن ملف SRT ماشي على الشكل العادي',
      'اتأكد إن التوقيتات مكتوبة كده: HH:MM:SS,mmm → HH:MM:SS,mmm',
      'اتأكد إن أرقام السطور ورا بعض',
      'سيب سطر فاضي بين كل جزء والتاني',
      'اتأكد إن كل بداية قبل نهايتها',
    ],
    expectedFormat: 'شكل ملف SRT المطلوب:',
    tryAnother: 'جرّب ملف تاني',
  },

  captionStyle: {
    templates: {
      minimal: 'بسيط',
      neon: 'نيون',
      tiktok: 'تيك توك',
      comic: 'كوميك',
      elegant: 'شيك',
      glitch: 'جليتش',
      bold: 'تقيل',
      clean: 'نضيف',
      outline: 'بحدود',
    },
    cases: {
      normal: 'زي ما هو',
      uppercase: 'حروف كبيرة',
      lowercase: 'حروف صغيرة',
      capitalize: 'أول حرف كبير',
    },
    animations: {
      fade: 'ظهور تدريجي',
      tiktok: 'تيك توك',
      slide: 'انزلاق',
      pop: 'نطّة',
      glitch: 'جليتش',
    },
    text: 'الكلام',
    highlight: 'التمييز',
    stroke: 'الحدود',
    customize: 'خصّصه',
    position: 'المكان',
    fontAndText: 'الخط والكلام',
    fontPlaceholder: 'الخط...',
    size: 'الحجم',
    casePlaceholder: 'شكل الحروف...',
    outline: 'الحدود',
    shadow: 'الضل',
    background: 'الخلفية',
    showBackground: 'اظهر الخلفية',
    color: 'اللون',
    opacity: 'الشفافية',
    animationAndTiming: 'الحركة والتوقيت',
    animationPlaceholder: 'الحركة...',
    speed: 'السرعة',
    highlightScale: 'حجم التمييز ({n}%)',
    words: 'الكلمات',
    spacing: 'المسافات',
    lineHeight: 'المسافة بين السطور',
    letterSpacing: 'المسافة بين الحروف',
    normalSpacing: 'عادي',
    transforms: 'الشكل',
    rotation: 'اللف',
    skew: 'الميل',
    scale: 'الحجم',
  },

  textPanel: {
    elements: 'عناصر',
    hookTitle: 'عنوان يشد',
    hookDefault: 'استنى…',
    hookOver: '“{text}” في أول 3 ثواني',
    templates: {
      modern: { name: 'عنوان مودرن', preview: 'شيك وبسيط' },
      impact: { name: 'جملة قوية', preview: 'تقيل وواضح' },
      slicedText: { name: 'كلام متقطّع', preview: 'جريء ومودرن' },
      minimalMonochrome: { name: 'بسيط بلون واحد', preview: 'بسيط جدًا' },
      highlight: { name: 'مربع مميّز', preview: 'مودرن ومختلف' },
      gradient: { name: 'ألوان متدرجة', preview: 'حيوي ومودرن' },
      neonFuture: { name: 'نيون', preview: 'مشحون وتقيل' },
      avantGarde: { name: 'فاشون', preview: 'على الموضة' },
      glassmorphic: { name: 'زجاج', preview: 'شفافية مودرن' },
    },
  },

  textDetails: {
    preview: 'شكل الكلام',
    placeholder: 'اكتب كلامك هنا...',
    settings: 'الإعدادات',
    style: 'الستايل',
    typography: 'الخط',
    fontFamily: 'نوع الخط',
    selectFont: 'اختار خط',
    fonts: {
      sans: 'Inter (خط بسيط)',
      serif: 'Merriweather (خط بزوايد)',
      mono: 'Roboto Mono (حروف بعرض واحد)',
    },
    alignment: 'المحاذاة',
    alignLeft: 'على الشمال',
    alignCenter: 'في النص',
    alignRight: 'على اليمين',
    colors: 'الألوان',
    textColor: 'لون الكلام',
    highlight: 'التمييز',
    gradientNoColors: 'الألوان مش بتتغير في ستايلات الكلام المتدرجة',
  },
};
